<div class="info-tile-container">
    <app-info-tile
        [infoName]="'Total Records'"
        [infoValue]="vaccinationStats.totalVaccinations"
    >
    </app-info-tile>

    <app-info-tile
        [infoName]="'Days of The Cycle'"
        [infoValue]="vaccinationStats.dayOfTheCycle"
    >
    </app-info-tile>

    <app-info-tile
        [infoName]="'Finished Vaccination Programs'"
        [infoValue]="vaccinationStats.finishedPrograms"
    >
    </app-info-tile>
</div>
